import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgSatisfiedSelectedEmojiSecondary from './svgs/SatisfiedSelectedEmojiSecondary.js';
import SvgSatisfiedSelectedEmoji from './svgs/SatisfiedSelectedEmoji.js';
import { useIcon } from '../../shared-components/icon/index.js';

var satisfiedSelectedEmoji = (props => useIcon(SvgSatisfiedSelectedEmoji, SvgSatisfiedSelectedEmojiSecondary, props));

export { satisfiedSelectedEmoji as default };
